module.exports = __webpack_public_path__ + "media/7.b034ef96.wav";